import { pageIntroContent } from '@insify/css/classes.module.css';
import { FormProvider, useForm } from 'react-hook-form';

import { RichContentWithTooltip } from '../../components/RichContent';
import { WizardLayoutFormWithCommonSection } from '../../components/WizardLayoutForm';

import type { RichContentType } from '../../components/RichContent';
import type { FieldValues, Resolver } from 'react-hook-form';

export type ContainerProps<TFormType extends FieldValues> = {
  formData: Partial<TFormType> | undefined;
  inputs: JSX.Element;
  validation?: Resolver<TFormType, object>;
  eventHandlers: {
    onSubmit: (values: TFormType) => void;
    onBack: () => void;
  };
  content?: RichContentType;
  translations: {
    back: string;
    forward: string;
  };
  submitting: boolean;
};

export const FormContainer = <TFormType extends FieldValues>({
  formData,
  inputs,
  validation,
  eventHandlers,
  content,
  translations,
  submitting,
}: ContainerProps<TFormType>): JSX.Element => {
  const formMethods = useForm<TFormType>({
    shouldUnregister: true,
    resolver: validation,
    // @ts-ignore react-hook-form can't into generics
    defaultValues: formData,
    mode: 'onSubmit',
  });

  return (
    <FormProvider {...formMethods}>
      <WizardLayoutFormWithCommonSection
        backCopy={translations.back}
        onBack={eventHandlers.onBack}
        forwardCopy={translations.forward}
        isSubmitting={submitting}
        // @ts-ignore react-hook-form can't into generics
        onSubmit={formMethods.handleSubmit(eventHandlers.onSubmit)}
      >
        <RichContentWithTooltip content={content} className={pageIntroContent} />
        {inputs}
      </WizardLayoutFormWithCommonSection>
    </FormProvider>
  );
};
